export enum PATH {
  CHANGE_PASSWORD = '/changePassword',
  LOGOUT = '/logout',
  ORGANIZATION = '/organization',
  USER = '/user',
  SITE = '/site',
}
export interface Navigation {
  _tag: string;
  name?: string;
  className?: string;
  to?: PATH;
  icon?: string;
}
const nav: Navigation[] = [
  {
    _tag: 'CSidebarNavItem',
    name: '組織管理',
    to: PATH.ORGANIZATION,
    icon: 'cil-list',
  },

  {
    _tag: 'CSidebarNavItem',
    name: '組織ユーザ管理',
    to: PATH.USER,
    icon: 'cil-list',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'サイト管理',
    to: PATH.SITE,
    icon: 'cil-list',
  },

  {
    _tag: 'CSidebarNavDivider',
    className: 'sed-om-sidebar-divider mt-auto',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'パスワード変更',
    to: PATH.CHANGE_PASSWORD,
    icon: 'cil-user',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'ログアウト',
    to: PATH.LOGOUT,
    icon: 'cil-account-logout',
  },
  {
    _tag: 'CSidebarNavDivider',
    className: 'm-2',
  },
];

export default nav;
